import { motion } from "framer-motion";
import { Check, Globe2 } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import { THEME_LIST } from "../../lib/themes";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export function ThemeSwitcher({ open, onOpenChange }) {
  const { themeId, setTheme } = useTheme();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl flex items-center gap-2"><Globe2 className="w-6 h-6 text-primary" /> Kies je wereld</DialogTitle>
          <DialogDescription>Verander de hele sfeer van je avontuur. Kleuren, mascotte én woorden passen zich aan!</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4 mt-2">
          {THEME_LIST.map((t) => {
            const active = t.id === themeId;
            return (
              <motion.button key={t.id} whileHover={{ y: -4 }} whileTap={{ scale: 0.97 }}
                onClick={() => { setTheme(t.id); onOpenChange(false); }} data-testid={`theme-switcher-${t.id}`}
                className="relative text-left rounded-3xl p-5 overflow-hidden transition-shadow"
                style={{ background: t.colors.surface, border: `3px solid ${active ? t.colors.accent : t.colors.border}`, color: t.colors.text }}>
                {active && (
                  <span className="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center" style={{ background: t.colors.accent, color: t.colors.onAccent }}>
                    <Check className="w-4 h-4" strokeWidth={3} />
                  </span>
                )}
                <div className="flex items-center gap-3">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-3xl" style={{ background: t.colors.surface2 }}>{t.mascot}</div>
                  <div>
                    <p className="font-heading text-xl font-extrabold" style={{ fontFamily: t.fonts.heading }}>{t.name}</p>
                    <p className="text-sm" style={{ color: t.colors.muted }}>{t.tagline}</p>
                  </div>
                </div>
                <div className="flex gap-2 mt-4">
                  {[t.colors.primary, t.colors.accent, t.colors.success].map((col, i) => (
                    <span key={i} className="w-8 h-8 rounded-full" style={{ background: col }} />
                  ))}
                </div>
              </motion.button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
